import { AppRoutes } from "@/config/router";
import useAppContext from "@/utilities/hooks/useAppContext";
import UserStatusView from "./UserStatusView";
import { SortEnumType, UserDatalistDocument, UserDatalistQuery, UserDatalistQueryVariables, UserFilterInput, UserSortInput } from "@/types/graphql";
import { graph } from "@/config/axios-context";
import Datalist, { DatalistPropsType } from "@/components/common/datalist/Datalist";
import { NotNull } from "@/types/common-types";
import lodash from "lodash";
import { DeepPartial } from "@apollo/client/utilities";
import { DatalistOnClickType } from "@/types/datalist-types";

type UserDatalistType = NotNull<NotNull<NotNull<NotNull<UserDatalistQuery>['users']>['items']>[0]>;

type UserDatalistProps = {
    fixedFilters?: UserFilterInput;
    onItemClick?: DatalistOnClickType<UserDatalistType>
};

function UserDatalist(props: UserDatalistProps) {
    const context = useAppContext();

    
    let defaultConfig: DatalistPropsType<UserDatalistType, UserFilterInput, UserSortInput> = {
        itemId(i) {
            return i.id
        },
        dataSource: {
            request: async (params) => {
                let variables: UserDatalistQueryVariables = {
                    order: params.sort,
                    skip: params.skip,
                    take: params.take,
                    where: params.filters
                };

                if (props.fixedFilters) {
                    variables.where = {
                        and: [{
                            ...variables.where
                        }, {
                            ...props.fixedFilters
                        }]
                    };
                }

                if (params.searchText) {
                    const search: UserFilterInput = {
                        or: [
                            {
                                name: {
                                    contains: params.searchText
                                }
                            }, {
                                username: {
                                    contains: params.searchText
                                }
                            }, {
                                authData: {
                                    some: {
                                        identifier: {
                                            contains: params.searchText
                                        }
                                    }
                                }
                            }
                        ]
                    };

                    if (variables.where) {
                        variables.where = {
                            and: [{
                                ...variables.where
                            }, {
                                ...search
                            }]
                        }
                    } else {
                        variables.where = search;
                    }
                }

                try {
                    const response = await graph<UserDatalistQuery, UserDatalistQueryVariables>({
                        query: UserDatalistDocument,
                        variables: variables
                    });

                    if (response.errors?.length) throw response.errors;

                    return response.data?.users as any;
                } catch (error) {
                    context.notify('error', 'Shit went wrong');
                    throw error;
                }
            },
            sort: [{
                id: 'the-main-sort',
                direction: SortEnumType.Asc,
                name: 'name'
            }]
        },
        name: 'user-datalist-page',
        defaultView: 'table',
        table: {
            columns: [
                {
                    name: 'id',
                    card: {
                        hide: true
                    }
                },
                {
                    name: 'name',
                    filter: {
                        type: 'string'
                    },
                    sort: true
                },
                {
                    name: 'username',
                    filter: {
                        type: 'string'
                    },
                    sort: true
                },
                {
                    name: 'status',
                    title: 'fields.state.shortName',
                    sort: true,
                    resolve(i) {
                        return <UserStatusView status={i.status} />;
                    }
                }
            ]
        },
        onItemClick: props.onItemClick || {
            type: 'link',
            link: {
                url: AppRoutes.USER_VIEW,
                params: i => {
                    return {id: i.id};
                }
            }
        },
    }

    return (
        <Datalist {...defaultConfig} />
    );
}

export default UserDatalist;